import {
  Asset,
  AssetDetailResponse,
  AssetPriceSource,
  AssetsListResponse,
  CategoryConfig,
  CreateAssetRequest,
  UpdateAssetRequest,
  CreateProviderLinkRequest,
  UpdateProviderLinkRequest,
  UpdateCategoryConfigRequest,
  ProviderAssetLink,
  TradevestImportPreviewResponse,
  TradevestImportResponse,
  MessageResponse,
  CoinPaprikaSearchResult,
  TradingViewSearchResult,
  TestPriceResponse,
} from '@mygate/common';
import { api } from './api';

class AssetManagementService {
  async listAssets(params?: {
    category?: string;
    search?: string;
    page?: number;
    limit?: number;
    isActive?: boolean;
  }) {
    const queryParams = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
          queryParams.append(key, String(value));
        }
      });
    }
    const queryString = queryParams.toString();
    return api.get<AssetsListResponse>(`/api/staff/assets${queryString ? `?${queryString}` : ''}`);
  }

  async getAsset(id: string) {
    return api.get<AssetDetailResponse>(`/api/staff/assets/${id}`);
  }

  async createAsset(data: CreateAssetRequest) {
    return api.post<Asset>(`/api/staff/assets`, data);
  }

  async updateAsset(id: string, data: UpdateAssetRequest) {
    return api.patch<Asset>(`/api/staff/assets/${id}`, data);
  }

  async addProviderLink(assetId: string, data: CreateProviderLinkRequest) {
    return api.post<ProviderAssetLink>(`/api/staff/assets/${assetId}/providers`, data);
  }

  async updateProviderLink(assetId: string, linkId: string, data: UpdateProviderLinkRequest) {
    return api.patch<ProviderAssetLink>(`/api/staff/assets/${assetId}/providers/${linkId}`, data);
  }

  async deleteProviderLink(assetId: string, linkId: string) {
    return api.delete<MessageResponse>(`/api/staff/assets/${assetId}/providers/${linkId}`);
  }

  async listCategories() {
    return api.get<CategoryConfig[]>(`/api/staff/asset-categories`);
  }

  async updateCategory(category: string, data: UpdateCategoryConfigRequest) {
    return api.patch<CategoryConfig>(`/api/staff/asset-categories/${category}`, data);
  }

  async previewTradevestImport() {
    return api.get<TradevestImportPreviewResponse>(`/api/staff/assets/import/tradevest/preview`);
  }

  async executeTradevestImport(symbols: string[]) {
    return api.post<TradevestImportResponse>(`/api/staff/assets/import/tradevest`, { symbols });
  }

  async testPrice(priceSource: AssetPriceSource, priceSymbol?: string) {
    return api.post<TestPriceResponse>('/api/staff/assets/test-price', { priceSource, priceSymbol });
  }

  async searchCoinPaprika(q: string) {
    return api.get<CoinPaprikaSearchResult[]>(
      `/api/staff/assets/search/coinpaprika?q=${encodeURIComponent(q)}`,
    );
  }

  async searchTradingView(q: string) {
    return api.get<TradingViewSearchResult[]>(
      `/api/staff/assets/search/tradingview?q=${encodeURIComponent(q)}`,
    );
  }
}

export const assetManagementService = new AssetManagementService();
